var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQbBallOnlyPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.076807975769043, 0, 0, 5.076807975769043, -1189.8583984375, -526.5314331054688)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2CA01C",
    fillRule: "evenodd",
    d: "M 234.597 153.073 C 234.597 126.011 256.312 104.073 283.097 104.073 C 309.883 104.073 331.597 126.011 331.597 153.073 C 331.597 180.134 309.883 202.073 283.097 202.073 C 256.312 202.073 234.597 180.134 234.597 153.073 Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M 299.484 134.091 L 296.754 134.091 L 296.754 141.141 L 299.484 141.141 C 306.108 141.141 311.498 146.495 311.498 153.075 C 311.498 159.654 306.108 165.007 299.484 165.007 L 292.923 165.007 L 292.923 128.124 C 292.923 124.23 289.744 121.073 285.824 121.073 L 285.824 172.059 L 299.484 172.059 C 310.04 172.059 318.597 163.559 318.597 153.075 C 318.597 142.59 310.04 134.091 299.484 134.091 Z M 247.597 153.071 C 247.597 163.556 256.154 172.055 266.71 172.055 L 269.44 172.055 L 269.44 165.004 L 266.71 165.004 C 260.086 165.004 254.696 159.652 254.696 153.071 C 254.696 146.492 260.086 141.139 266.71 141.139 L 273.271 141.139 L 273.271 178.022 C 273.271 181.916 276.45 185.073 280.37 185.073 L 280.37 134.087 L 266.71 134.087 C 256.154 134.087 247.597 142.587 247.597 153.071 Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQbBallOnlyPhoto);
export default __webpack_public_path__ + "static/media/qb-ball-only-photo.ab4db9ee85f690ea81a89ec81ad0cc73.svg";
export { ForwardRef as ReactComponent };